import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconNoTransactions } from '../../../assets/icons/svg/menu-icons/ic-menu-transactions.svg';
import Heading from '../../../generic-components/Heading';

export const LatestTransactionsZeroState = () => {
  const { t } = useTranslation();
  return (
    <div className='flex items-center justify-center flex-col self-center w-full h-full'>
      <IconNoTransactions />
      <Heading title={t('WIDGET_LATEST_TRANSACTIONS.ZERO_STATE')} className='font-metricR text-bw08 text-sm leading-4' testId='' />
    </div>
  );
};
